"use client"
import logger from "@/lib/logger/logger-init"
import { ResultFactory } from "@/types/generic/Result"

type DecreaseItemQuantityResult = {
    success: boolean
    data?: any
    error?: Error
}

export const decreaseItemQuantity = async (formData: FormData) => {
    try {
        const response = await fetch("/api/centra/decrease-quantity", {
            method: "POST",
            credentials: "include",
            body: formData
        })

        const result = await response.json()

        if (!response.ok || !result.success) {
            const errorMessage = result.error || "Failed to decrease quantity"
            logger.warn(errorMessage)
            return ResultFactory.failure<DecreaseItemQuantityResult>(
                new Error(errorMessage)
            )
        }
        return ResultFactory.success<DecreaseItemQuantityResult>({
            success: true,
            data: result.data
        })
    } catch (error) {
        logger.error("Unexpected error in decreaseItemQuantity", error)
        return ResultFactory.failure<DecreaseItemQuantityResult>(
            error instanceof Error ? error : new Error("An unknown error occurred")
        )
    }
}
